/**
 * Generated from PostcardMunich2Layout.fla
 */
export function PostcardMunich2Layout(this: IPostcardMunich2Layout) {
	const main = this.main;
	PostcardMunich2Layout_main.call(this.main);
	main.x = 1024;
	main.y = 768;
	if (main.onLayout) main.onLayout();
	return this;
}
export function PostcardMunich2Layout_main(this: IPostcardMunich2Layout_main) {
	const postcard = this.postcard;
	PostcardMunich2Layout_postcard.call(this.postcard);
	postcard.x = 0;
	postcard.y = 4.7;
	if (postcard.scale) postcard.scale.x = 0.633;
	if (postcard.scale) postcard.scale.y = 0.633;
	if (postcard.onLayout) postcard.onLayout();
	return this;
}
function PostcardMunich2Layout_postcard(this: IPostcardMunich2Layout_postcard) {
	const cardTransform = this.cardTransform;
	if (!cardTransform[0] && cardTransform.elementFactory) {
		cardTransform[0] = cardTransform.elementFactory(0,undefined);
	}
	if (cardTransform[0]) {
		PostcardMunich2Layout_cardTransform1.call(cardTransform[0] as IPostcardMunich2Layout_cardTransform1);
		cardTransform[0].x = 59.55;
		cardTransform[0].y = -447.6;
		cardTransform[0].width = 613.30;
		cardTransform[0].height = 768.76;
		if (cardTransform[0].onLayout) cardTransform[0].onLayout();
	}
	if (!cardTransform[1] && cardTransform.elementFactory) {
		cardTransform[1] = cardTransform.elementFactory(1,undefined);
	}
	if (cardTransform[1]) {
		PostcardMunich2Layout_cardTransform2.call(cardTransform[1] as IPostcardMunich2Layout_cardTransform2);
		cardTransform[1].x = 182;
		cardTransform[1].y = -52;
		cardTransform[1].width = 537.64;
		cardTransform[1].height = 673.92;
		if (cardTransform[1].onLayout) cardTransform[1].onLayout();
	}
	if (!cardTransform[2] && cardTransform.elementFactory) {
		cardTransform[2] = cardTransform.elementFactory(2,undefined);
	}
	if (cardTransform[2]) {
		PostcardMunich2Layout_cardTransform3.call(cardTransform[2] as IPostcardMunich2Layout_cardTransform3);
		cardTransform[2].x = 563.1;
		cardTransform[2].y = 263.75;
		cardTransform[2].width = 595.72;
		cardTransform[2].height = 746.72;
		if (cardTransform[2].onLayout) cardTransform[2].onLayout();
	}
	if (!cardTransform[3] && cardTransform.elementFactory) {
		cardTransform[3] = cardTransform.elementFactory(3,undefined);
	}
	if (cardTransform[3]) {
		PostcardMunich2Layout_cardTransform4.call(cardTransform[3] as IPostcardMunich2Layout_cardTransform4);
		cardTransform[3].x = 263.8;
		cardTransform[3].y = 263.5;
		cardTransform[3].width = 214.43;
		cardTransform[3].height = 268.78;
		if (cardTransform[3].onLayout) cardTransform[3].onLayout();
	}
	if (!cardTransform[4] && cardTransform.elementFactory) {
		cardTransform[4] = cardTransform.elementFactory(4,undefined);
	}
	if (cardTransform[4]) {
		PostcardMunich2Layout_cardTransform5.call(cardTransform[4] as IPostcardMunich2Layout_cardTransform5);
		cardTransform[4].x = -459.25;
		cardTransform[4].y = 257.9;
		cardTransform[4].width = 932.99;
		cardTransform[4].height = 1169.48;
		if (cardTransform[4].onLayout) cardTransform[4].onLayout();
	}
	if (!cardTransform[5] && cardTransform.elementFactory) {
		cardTransform[5] = cardTransform.elementFactory(5,undefined);
	}
	if (cardTransform[5]) {
		PostcardMunich2Layout_cardTransform6.call(cardTransform[5] as IPostcardMunich2Layout_cardTransform6);
		cardTransform[5].x = 584.55;
		cardTransform[5].y = -329.15;
		cardTransform[5].width = 463.67;
		cardTransform[5].height = 581.19;
		if (cardTransform[5].onLayout) cardTransform[5].onLayout();
	}
	if (!cardTransform[6] && cardTransform.elementFactory) {
		cardTransform[6] = cardTransform.elementFactory(6,undefined);
	}
	if (cardTransform[6]) {
		PostcardMunich2Layout_cardTransform7.call(cardTransform[6] as IPostcardMunich2Layout_cardTransform7);
		cardTransform[6].x = -292.6;
		cardTransform[6].y = -172.25;
		cardTransform[6].width = 561.73;
		cardTransform[6].height = 704.11;
		if (cardTransform[6].onLayout) cardTransform[6].onLayout();
	}
	if (!cardTransform[7] && cardTransform.elementFactory) {
		cardTransform[7] = cardTransform.elementFactory(7,undefined);
	}
	if (cardTransform[7]) {
		PostcardMunich2Layout_cardTransform8.call(cardTransform[7] as IPostcardMunich2Layout_cardTransform8);
		cardTransform[7].x = -596.95;
		cardTransform[7].y = -403.45;
		cardTransform[7].width = 549.00;
		cardTransform[7].height = 688.16;
		if (cardTransform[7].onLayout) cardTransform[7].onLayout();
	}
	const items = this.items;
	if (!items[0] && items.elementFactory) {
		items[0] = items.elementFactory(0,{"dependsOn":0,"outlineGlow":true});
	}
	if (items[0]) {
		PostcardMunich2Layout_pieces7.call(items[0] as IPostcardMunich2Layout_pieces7);
		(items[0] as IPostcardMunich2Layout_pieces7).dependsOn = 0;
		(items[0] as IPostcardMunich2Layout_pieces7).outlineGlow = true;
		items[0].x = -288.45;
		items[0].y = -149.45;
		items[0].width = 416.00;
		items[0].height = 219.00;
		if (items[0].onLayout) items[0].onLayout();
	}
	if (!items[1] && items.elementFactory) {
		items[1] = items.elementFactory(1,undefined);
	}
	if (items[1]) {
		PostcardMunich2Layout_outlines7.call(items[1] as IPostcardMunich2Layout_outlines7);
		items[1].x = -299.3;
		items[1].y = -162.5;
		items[1].width = 374.00;
		items[1].height = 194.00;
		if (items[1].onLayout) items[1].onLayout();
	}
	if (!items[2] && items.elementFactory) {
		items[2] = items.elementFactory(2,{"dependsOn":0,"outlineGlow":true});
	}
	if (items[2]) {
		PostcardMunich2Layout_pieces8.call(items[2] as IPostcardMunich2Layout_pieces8);
		(items[2] as IPostcardMunich2Layout_pieces8).dependsOn = 0;
		(items[2] as IPostcardMunich2Layout_pieces8).outlineGlow = true;
		items[2].x = -583.65;
		items[2].y = -396.05;
		items[2].width = 592.00;
		items[2].height = 356.00;
		if (items[2].onLayout) items[2].onLayout();
	}
	if (!items[3] && items.elementFactory) {
		items[3] = items.elementFactory(3,undefined);
	}
	if (items[3]) {
		PostcardMunich2Layout_outlines8.call(items[3] as IPostcardMunich2Layout_outlines8);
		items[3].x = -597.95;
		items[3].y = -403.45;
		items[3].width = 378.00;
		items[3].height = 305.00;
		if (items[3].onLayout) items[3].onLayout();
	}
	if (!items[4] && items.elementFactory) {
		items[4] = items.elementFactory(4,{"dependsOn":0,"outlineGlow":true});
	}
	if (items[4]) {
		PostcardMunich2Layout_pieces1.call(items[4] as IPostcardMunich2Layout_pieces1);
		(items[4] as IPostcardMunich2Layout_pieces1).dependsOn = 0;
		(items[4] as IPostcardMunich2Layout_pieces1).outlineGlow = true;
		items[4].x = 54.95;
		items[4].y = -415.3;
		items[4].width = 717.00;
		items[4].height = 218.00;
		if (items[4].onLayout) items[4].onLayout();
	}
	if (!items[5] && items.elementFactory) {
		items[5] = items.elementFactory(5,undefined);
	}
	if (items[5]) {
		PostcardMunich2Layout_outlines1.call(items[5] as IPostcardMunich2Layout_outlines1);
		items[5].x = 68.2;
		items[5].y = -437.1;
		items[5].width = 441.00;
		items[5].height = 173.00;
		if (items[5].onLayout) items[5].onLayout();
	}
	if (!items[6] && items.elementFactory) {
		items[6] = items.elementFactory(6,{"dependsOn":0,"outlineGlow":true});
	}
	if (items[6]) {
		PostcardMunich2Layout_pieces6.call(items[6] as IPostcardMunich2Layout_pieces6);
		(items[6] as IPostcardMunich2Layout_pieces6).dependsOn = 0;
		(items[6] as IPostcardMunich2Layout_pieces6).outlineGlow = true;
		items[6].x = 589.75;
		items[6].y = -332.75;
		items[6].width = 391.00;
		items[6].height = 478.00;
		if (items[6].onLayout) items[6].onLayout();
	}
	if (!items[7] && items.elementFactory) {
		items[7] = items.elementFactory(7,undefined);
	}
	if (items[7]) {
		PostcardMunich2Layout_outlines6.call(items[7] as IPostcardMunich2Layout_outlines6);
		items[7].x = 586.8;
		items[7].y = -346.95;
		items[7].width = 302.00;
		items[7].height = 446.00;
		if (items[7].onLayout) items[7].onLayout();
	}
	if (!items[8] && items.elementFactory) {
		items[8] = items.elementFactory(8,{"dependsOn":0,"outlineGlow":true});
	}
	if (items[8]) {
		PostcardMunich2Layout_pieces2.call(items[8] as IPostcardMunich2Layout_pieces2);
		(items[8] as IPostcardMunich2Layout_pieces2).dependsOn = 0;
		(items[8] as IPostcardMunich2Layout_pieces2).outlineGlow = true;
		items[8].x = 199.1;
		items[8].y = -38.75;
		items[8].width = 457.99;
		items[8].height = 389.99;
		if (items[8].onLayout) items[8].onLayout();
	}
	if (!items[9] && items.elementFactory) {
		items[9] = items.elementFactory(9,undefined);
	}
	if (items[9]) {
		PostcardMunich2Layout_outlines2.call(items[9] as IPostcardMunich2Layout_outlines2);
		items[9].x = 187.8;
		items[9].y = -48.3;
		items[9].width = 336.00;
		items[9].height = 374.00;
		if (items[9].onLayout) items[9].onLayout();
	}
	if (!items[10] && items.elementFactory) {
		items[10] = items.elementFactory(10,{"dependsOn":0,"outlineGlow":true});
	}
	if (items[10]) {
		PostcardMunich2Layout_pieces4.call(items[10] as IPostcardMunich2Layout_pieces4);
		(items[10] as IPostcardMunich2Layout_pieces4).dependsOn = 0;
		(items[10] as IPostcardMunich2Layout_pieces4).outlineGlow = true;
		items[10].x = 405.75;
		items[10].y = 382.85;
		items[10].width = 823.00;
		items[10].height = 382.00;
		if (items[10].onLayout) items[10].onLayout();
	}
	if (!items[11] && items.elementFactory) {
		items[11] = items.elementFactory(11,undefined);
	}
	if (items[11]) {
		PostcardMunich2Layout_outlines4.call(items[11] as IPostcardMunich2Layout_outlines4);
		items[11].x = 412;
		items[11].y = 352.1;
		items[11].width = 452.00;
		items[11].height = 312.00;
		if (items[11].onLayout) items[11].onLayout();
	}
	if (!items[12] && items.elementFactory) {
		items[12] = items.elementFactory(12,{"dependsOn":0,"outlineGlow":true});
	}
	if (items[12]) {
		PostcardMunich2Layout_pieces5.call(items[12] as IPostcardMunich2Layout_pieces5);
		(items[12] as IPostcardMunich2Layout_pieces5).dependsOn = 0;
		(items[12] as IPostcardMunich2Layout_pieces5).outlineGlow = true;
		items[12].x = -360.2;
		items[12].y = 312.3;
		items[12].width = 900.00;
		items[12].height = 618.00;
		if (items[12].onLayout) items[12].onLayout();
	}
	if (!items[13] && items.elementFactory) {
		items[13] = items.elementFactory(13,undefined);
	}
	if (items[13]) {
		PostcardMunich2Layout_outlines5.call(items[13] as IPostcardMunich2Layout_outlines5);
		items[13].x = -457;
		items[13].y = 274.45;
		items[13].width = 681.00;
		items[13].height = 547.00;
		if (items[13].onLayout) items[13].onLayout();
	}
	const background = this.background;
	PostcardMunich2Layout_background.call(this.background);
	background.x = 0;
	background.y = 0;
	background.width = 1790.00;
	background.height = 1325.00;
	if (background.onLayout) background.onLayout();
	const postcardOverlay = this.postcardOverlay;
	PostcardMunich2Layout_postcardOverlay.call(this.postcardOverlay);
	postcardOverlay.x = 0;
	postcardOverlay.y = 0;
	postcardOverlay.width = 1784.00;
	postcardOverlay.height = 1318.00;
	if (postcardOverlay.onLayout) postcardOverlay.onLayout();
	const postcardMask = this.postcardMask;
	postcardMask.push(11.60,-642.40,878.60,-641.10,869.70,11.90,875.65,626.30,29.70,629.25,-492.65,638.15,-880.20,652.65,-875.55,-47.50,-881.50,-655.95);
	return this;
}
function PostcardMunich2Layout_background(this: IPostcardMunich2Layout_background) {
	if (this.setLayoutTexture) this.setLayoutTexture("postcard-munich-2.png", 0.501, 0.500);
	return this;
}
function PostcardMunich2Layout_cardTransform8(this: IPostcardMunich2Layout_cardTransform8) {
	if (this.setLayoutTexture) this.setLayoutTexture("card-munich-2-8.png", 0.500, 0.500);
	return this;
}
function PostcardMunich2Layout_cardTransform6(this: IPostcardMunich2Layout_cardTransform6) {
	if (this.setLayoutTexture) this.setLayoutTexture("card-munich-2-6.png", 0.500, 0.500);
	return this;
}
function PostcardMunich2Layout_cardTransform1(this: IPostcardMunich2Layout_cardTransform1) {
	if (this.setLayoutTexture) this.setLayoutTexture("card-munich-2-1.png", 0.500, 0.500);
	return this;
}
function PostcardMunich2Layout_cardTransform7(this: IPostcardMunich2Layout_cardTransform7) {
	if (this.setLayoutTexture) this.setLayoutTexture("card-munich-2-7.png", 0.500, 0.500);
	return this;
}
function PostcardMunich2Layout_cardTransform2(this: IPostcardMunich2Layout_cardTransform2) {
	if (this.setLayoutTexture) this.setLayoutTexture("card-munich-2-2.png", 0.500, 0.500);
	return this;
}
function PostcardMunich2Layout_cardTransform3(this: IPostcardMunich2Layout_cardTransform3) {
	if (this.setLayoutTexture) this.setLayoutTexture("card-munich-2-3.png", 0.500, 0.500);
	return this;
}
function PostcardMunich2Layout_cardTransform5(this: IPostcardMunich2Layout_cardTransform5) {
	if (this.setLayoutTexture) this.setLayoutTexture("card-munich-2-5.png", 0.500, 0.500);
	return this;
}
function PostcardMunich2Layout_cardTransform4(this: IPostcardMunich2Layout_cardTransform4) {
	if (this.setLayoutTexture) this.setLayoutTexture("card-munich-2-4.png", 0.500, 0.500);
	return this;
}
function PostcardMunich2Layout_pieces7(this: IPostcardMunich2Layout_pieces7) {
	if (this.setLayoutTexture) this.setLayoutTexture("piece-munich-2-7.png", 0.500, 0.502);
	return this;
}
function PostcardMunich2Layout_outlines7(this: IPostcardMunich2Layout_outlines7) {
	if (this.setLayoutTexture) this.setLayoutTexture("outline-munich-2-7.png", 0.500, 0.500);
	return this;
}
function PostcardMunich2Layout_pieces8(this: IPostcardMunich2Layout_pieces8) {
	if (this.setLayoutTexture) this.setLayoutTexture("piece-munich-2-8.png", 0.424, 0.452);
	return this;
}
function PostcardMunich2Layout_outlines8(this: IPostcardMunich2Layout_outlines8) {
	if (this.setLayoutTexture) this.setLayoutTexture("outline-munich-2-8.png", 0.500, 0.502);
	return this;
}
function PostcardMunich2Layout_pieces1(this: IPostcardMunich2Layout_pieces1) {
	if (this.setLayoutTexture) this.setLayoutTexture("piece-munich-2-1.png", 0.501, 0.500);
	return this;
}
function PostcardMunich2Layout_outlines1(this: IPostcardMunich2Layout_outlines1) {
	if (this.setLayoutTexture) this.setLayoutTexture("outline-munich-2-1.png", 0.501, 0.503);
	return this;
}
function PostcardMunich2Layout_pieces6(this: IPostcardMunich2Layout_pieces6) {
	if (this.setLayoutTexture) this.setLayoutTexture("piece-munich-2-6.png", 0.501, 0.500);
	return this;
}
function PostcardMunich2Layout_outlines6(this: IPostcardMunich2Layout_outlines6) {
	if (this.setLayoutTexture) this.setLayoutTexture("outline-munich-2-6.png", 0.500, 0.500);
	return this;
}
function PostcardMunich2Layout_pieces2(this: IPostcardMunich2Layout_pieces2) {
	if (this.setLayoutTexture) this.setLayoutTexture("piece-munich-2-2.png", 0.500, 0.500);
	return this;
}
function PostcardMunich2Layout_outlines2(this: IPostcardMunich2Layout_outlines2) {
	if (this.setLayoutTexture) this.setLayoutTexture("outline-munich-2-2.png", 0.500, 0.500);
	return this;
}
function PostcardMunich2Layout_pieces4(this: IPostcardMunich2Layout_pieces4) {
	if (this.setLayoutTexture) this.setLayoutTexture("piece-munich-2-4.png", 0.454, 0.487);
	return this;
}
function PostcardMunich2Layout_outlines4(this: IPostcardMunich2Layout_outlines4) {
	if (this.setLayoutTexture) this.setLayoutTexture("outline-munich-2-4.png", 0.500, 0.500);
	return this;
}
function PostcardMunich2Layout_pieces5(this: IPostcardMunich2Layout_pieces5) {
	if (this.setLayoutTexture) this.setLayoutTexture("piece-munich-2-5.png", 0.567, 0.502);
	return this;
}
function PostcardMunich2Layout_outlines5(this: IPostcardMunich2Layout_outlines5) {
	if (this.setLayoutTexture) this.setLayoutTexture("outline-munich-2-5.png", 0.501, 0.501);
	return this;
}
function PostcardMunich2Layout_postcardOverlay(this: IPostcardMunich2Layout_postcardOverlay) {
	if (this.setLayoutTexture) this.setLayoutTexture("postcard-border.png", 0.500, 0.500);
	return this;
}
function PostcardMunich2Layout_postcardMask(this: IPostcardMunich2Layout_postcardMask) {
	return this;
}
interface IPostcardMunich2LayoutArray<T> {
	[index: number]: T;
	elementFactory?(index:number, parameters?:any): T;
}
interface IPostcardMunich2LayoutContainer {
	x?: number;
	y?: number;
	scale?: {x:number, y:number};
	rotation?: number;
	width?: number;
	height?: number;
	onLayout?(): void;
}
interface IPostcardMunich2LayoutSprite extends IPostcardMunich2LayoutContainer {
	setLayoutTexture?(name: string, anchorX :number, anchorY :number): void;
}
interface IPostcardMunich2LayoutText extends IPostcardMunich2LayoutContainer {
	fontSize: number;
	textAreaWidth: number;
	textAreaHeight: number;
}
interface IPostcardMunich2LayoutPolygon extends Array<number> {
}
interface IPostcardMunich2Layout {
	readonly main: IPostcardMunich2Layout_main;
}
interface IPostcardMunich2Layout_main extends IPostcardMunich2LayoutContainer {
	readonly postcard: IPostcardMunich2Layout_postcard;
}
interface IPostcardMunich2Layout_postcard extends IPostcardMunich2LayoutContainer {
	readonly cardTransform: IPostcardMunich2LayoutArray<IPostcardMunich2Layout_cardTransform1|IPostcardMunich2Layout_cardTransform2|IPostcardMunich2Layout_cardTransform3|IPostcardMunich2Layout_cardTransform4|IPostcardMunich2Layout_cardTransform5|IPostcardMunich2Layout_cardTransform6|IPostcardMunich2Layout_cardTransform7|IPostcardMunich2Layout_cardTransform8>;
	readonly items: IPostcardMunich2LayoutArray<IPostcardMunich2Layout_pieces7|IPostcardMunich2Layout_outlines7|IPostcardMunich2Layout_pieces8|IPostcardMunich2Layout_outlines8|IPostcardMunich2Layout_pieces1|IPostcardMunich2Layout_outlines1|IPostcardMunich2Layout_pieces6|IPostcardMunich2Layout_outlines6|IPostcardMunich2Layout_pieces2|IPostcardMunich2Layout_outlines2|IPostcardMunich2Layout_pieces4|IPostcardMunich2Layout_outlines4|IPostcardMunich2Layout_pieces5|IPostcardMunich2Layout_outlines5>;
	readonly background: IPostcardMunich2Layout_background;
	readonly postcardOverlay: IPostcardMunich2Layout_postcardOverlay;
	readonly postcardMask: IPostcardMunich2Layout_postcardMask;
}
interface IPostcardMunich2Layout_background extends IPostcardMunich2LayoutSprite {
}
interface IPostcardMunich2Layout_cardTransform8 extends IPostcardMunich2LayoutSprite {
}
interface IPostcardMunich2Layout_cardTransform6 extends IPostcardMunich2LayoutSprite {
}
interface IPostcardMunich2Layout_cardTransform1 extends IPostcardMunich2LayoutSprite {
}
interface IPostcardMunich2Layout_cardTransform7 extends IPostcardMunich2LayoutSprite {
}
interface IPostcardMunich2Layout_cardTransform2 extends IPostcardMunich2LayoutSprite {
}
interface IPostcardMunich2Layout_cardTransform3 extends IPostcardMunich2LayoutSprite {
}
interface IPostcardMunich2Layout_cardTransform5 extends IPostcardMunich2LayoutSprite {
}
interface IPostcardMunich2Layout_cardTransform4 extends IPostcardMunich2LayoutSprite {
}
interface IPostcardMunich2Layout_pieces7 extends IPostcardMunich2LayoutSprite {
	dependsOn: number;
	outlineGlow: boolean;
}
interface IPostcardMunich2Layout_outlines7 extends IPostcardMunich2LayoutSprite {
}
interface IPostcardMunich2Layout_pieces8 extends IPostcardMunich2LayoutSprite {
	dependsOn: number;
	outlineGlow: boolean;
}
interface IPostcardMunich2Layout_outlines8 extends IPostcardMunich2LayoutSprite {
}
interface IPostcardMunich2Layout_pieces1 extends IPostcardMunich2LayoutSprite {
	dependsOn: number;
	outlineGlow: boolean;
}
interface IPostcardMunich2Layout_outlines1 extends IPostcardMunich2LayoutSprite {
}
interface IPostcardMunich2Layout_pieces6 extends IPostcardMunich2LayoutSprite {
	dependsOn: number;
	outlineGlow: boolean;
}
interface IPostcardMunich2Layout_outlines6 extends IPostcardMunich2LayoutSprite {
}
interface IPostcardMunich2Layout_pieces2 extends IPostcardMunich2LayoutSprite {
	dependsOn: number;
	outlineGlow: boolean;
}
interface IPostcardMunich2Layout_outlines2 extends IPostcardMunich2LayoutSprite {
}
interface IPostcardMunich2Layout_pieces4 extends IPostcardMunich2LayoutSprite {
	dependsOn: number;
	outlineGlow: boolean;
}
interface IPostcardMunich2Layout_outlines4 extends IPostcardMunich2LayoutSprite {
}
interface IPostcardMunich2Layout_pieces5 extends IPostcardMunich2LayoutSprite {
	dependsOn: number;
	outlineGlow: boolean;
}
interface IPostcardMunich2Layout_outlines5 extends IPostcardMunich2LayoutSprite {
}
interface IPostcardMunich2Layout_postcardOverlay extends IPostcardMunich2LayoutSprite {
}
interface IPostcardMunich2Layout_postcardMask extends IPostcardMunich2LayoutPolygon {
}
